module.exports = ".disp-inlineblk{display:inline-block}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/access-management/roles/role-scope-options/role-scope-options.component.scss
// module id = ./src/app/access-management/roles/role-scope-options/role-scope-options.component.scss
// module chunks = access-management.module